// extracted by mini-css-extract-plugin
export default {"numberColorOverride":"styles_numberColorOverride__foKbc"};